import actions from '../actions';

const initialState = {
    token: null,
    email: null,
    initial: true,
    signIn: {
        signingIn: false,
        signedIn: false,
        signInFailed: false,
        statusText: null
    },
    getUser: {
        fetching: false,
        fetched: false,
        fetchFailed: false
    },
    user: {}
};

export default function userAccount(state = initialState, action) {
    switch(action.type) {

        case actions.SIGNIN_REQUEST: {
            return Object.assign({}, state, {
                signIn: { signingIn: true, signedIn: false, signInFailed: false, statusText: null }
            });
        }
        case actions.SIGNIN_SUCCESS: {
            return Object.assign({}, state, {
                signIn: { signingIn: false, signedIn: true, signInFailed: false },
                user: Object.assign({}, action.user.user),
                token: action.user.token.token
            });
        }
        case actions.SIGNIN_FAILED: {
            return Object.assign({}, state, {
                signIn: { signingIn: false, signedIn: false, signInFailed: true, statusText: action.errorMessage }
            });
        }
        case actions.GET_USER_REQUEST: {
            return Object.assign({}, state, {
                getUser: Object.assign({}, state.getUser, {
                    fetching: true,
                    fetched: false,
                    fetchFailed: false
                })
            })
        }
        case actions.GET_USER_SUCCESS: {
            return Object.assign({}, state, {
                getUser: Object.assign({}, state.getUser, {
                    fetching: false,
                    fetched: true,
                    fetchFailed: false
                }),
                user: action.user,
                token: action.token
            });
        }
        case actions.GET_USER_FAILED: {
            return Object.assign({}, state, {
                getUser: Object.assign({}, state.getUser, {
                    fetching: false,
                    fetched: false,
                    fetchFailed: true,
                    statusText: action.errorMessage
                })
            })
        }
        case actions.INITIAL_GET_USER_DONE: {
            return Object.assign({}, state, {
                initial: false
            })
        }
        case actions.LOGOUT:
            const newState = JSON.parse(JSON.stringify(initialState));
            newState.initial = false;
            return newState;
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userAccountReducer.js